import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import { Input, Row, Col, Card, CardBody, Button } from "reactstrap";

const AddQuestionCategoryForm = ({show, labels, isAddOrEdit, selectedRow, setSelectedRow, selectedCategoryType, setSelectedCategoryType, handleImageUpload, onTranslateClickHandler, lastTranslatedField  }) => {
    const { t, i18n } = useTranslation();
    const [focused, setFocused] = useState({});
    const [formData, setFormData] = useState(selectedRow);
    const [lang, setLang] = useState();
    
    const today = new Date().toISOString().split("T")[0];

    const { QuestionTypes, Translations } = useSelector((state) => ({
        QuestionTypes: state.Common.questionTypes,
        Translations: state.Module.translations,
    }));

    // const { QuestionCategory, QuestionTypes, DifficultyLevel } = useSelector((state) => ({
    //     QuestionCategory: state.QuestionCategory.questionCategory,
    //     QuestionTypes: state.Common.questionTypes,
    //     DifficultyLevel: state.Common.difficultyLevel
    // }));

    const onSelectCategoryType = (selectedList, selectedItem) => {
		setSelectedCategoryType(prevIDs => {
			if (prevIDs && prevIDs.includes(selectedItem.ID)) {
				return prevIDs; 
			} else {
				return [...(prevIDs || []), selectedItem.ID]; 
			}
		});
	};
	
	const onRemoveCategoryType = (selectedList, removedItem) => {
		setSelectedCategoryType(prevIDs => (prevIDs || []).filter(id => id !== removedItem.ID));
	};

    const onChangeHandler = (e) => {
        const { name, value } = e.target;
      
        setSelectedRow((prev) => ({
          ...prev,
          [name]: value
        }));
      
        setFormData((prev) => ({
          ...prev,
          [name]: value
        }));
    };
      
    
    
    const onhandleFocus = (e) => {
        const id = e.target.id;
        setFocused((prevFocused) => ({ ...prevFocused, [id]: true }));
    }

    useEffect(() => {
        if (Translations && typeof Translations === 'string' && lastTranslatedField) {
            setFormData((prev) => ({
                ...prev,
                [lastTranslatedField]: Translations,
            }));
            setSelectedRow((prev) => ({
                ...prev,
                [lastTranslatedField]: Translations,
            }));
        }
    }, [Translations]);
    
      
    // useEffect(() => {
    //     if (show) {
    //         setLang('')
    //     }
    // }, [show]);    

    // useEffect(() => {
    //     setFormData(selectedRow);
    // }, [selectedRow])

    return (
        <Row>
            { labels?.map((items) => {
                switch (items?.fieldName || items?.labelName) {
                    case 'text-box':
                        return (
                            <Col key={items?.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items?.labelName} className="col-form-label">{t(items?.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        placeholder={t(items.placeholder)}
                                        value={formData[items?.value] || ''}
                                        name={items?.name}
                                        onChange={(e) => onChangeHandler(e)}
                                        id={items?.labelName}
                                        onBlur={(e) => {
                                            onhandleFocus(e)
                                        }}
                                        focused={focused[items.labelName] && focused[items.labelName].toString()}
                                        required={items.required} />
                                </div>
                            </Col>
                        );

                    case 'text2-box':
                        return (
                            <Col key={items.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items.labelName} className="col-form-label">{t(items.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <div className="lang-change-wrap">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            placeholder={t(items.placeholder)}
                                            value={formData[items.value] || ''}
                                            name={items.name}
                                            onChange={(e) => onChangeHandler(e)}
                                            id={items.labelName}
                                            onBlur={onhandleFocus}
                                            required={items.required}
                                        />
                    
                                        <Button
                                            type="button"
                                            className="me-2"
                                            onClick={() => {
                                                onTranslateClickHandler(items.value, selectedRow[items.value]);
                                            }}>
                                            <i className="ri-translate"></i> 
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        );
                        

                    case 'textarea-box':
                        return (
                            <Col key={items?.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items?.labelName} className="col-form-label">{t(items?.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <Input
                                        rows="2"
                                        type="textarea"
                                        className="form-control"
                                        placeholder={t(items.placeholder)}
                                        defaultValue={formData[items?.value]}
                                        name={items?.name}
                                        onChange={(e) => onChangeHandler(e)}
                                        id={items?.labelName}
                                        onBlur={onhandleFocus}                     
                                        focused={focused[items.labelName] && focused[items.labelName].toString()}
                                        required={items.required} />
                                </div>
                            </Col>
                        );

                    case 'textarea2-box':
                        return (
                            <Col key={items.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items.labelName} className="col-form-label">{t(items.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                    
                                    <div className="lang-change-wrap">
                                        <Input
                                            type="textarea"
                                            className="form-control"
                                            placeholder={t(items.placeholder)}
                                            value={formData[items.value] || ''}
                                            name={items.name}
                                            onChange={(e) => onChangeHandler(e)}
                                            id={items.labelName}
                                            onBlur={onhandleFocus}
                                            required={items.required}
                                        />
                    
                                        <Button
                                            type="button"
                                            className="me-2"
                                            onClick={() => {
                                                onTranslateClickHandler(items.value, formData[items.value]);
                                            }}>
                                            <i className="ri-translate"></i> 
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        );

                    case 'number-box':
                        return (
                            <Col key={items?.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items?.labelName} className="col-form-label">{t(items?.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <Input
                                        type="number"
                                        className="form-control"
                                        placeholder={t(items.placeholder)}
                                        defaultValue={formData[items?.value]}
                                        name={items?.name}
                                        onChange={(e) => onChangeHandler(e)}
                                        id={items?.labelName}
                                        onBlur={onhandleFocus}
                                        focused={focused[items.labelName] && focused[items.labelName].toString()}
                                        required={items.required} />
                                </div>
                            </Col>
                        )

                    case 'check-box':
                        return (
                            <Col key={items?.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items?.labelName} className="col-form-label">{t(items?.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <Input
                                        type="checkbox"
                                        className="form-control"
                                        placeholder={t(items.placeholder)}
                                        defaultChecked={selectedRow[items?.value]}
                                        name={items?.name}
                                        onChange={(e) => onChangeHandler(e)}
                                        id={items?.labelName}
                                        onBlur={onhandleFocus}
                                        focused={focused[items.labelName] && focused[items.labelName].toString()}
                                        required={items.required} />
                                </div>
                            </Col>
                        );

                    case 'date':
                        return (
                            <Col key={items.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items.labelName} className="col-form-label">{t(items.labelName)}</label>
                                    <Input 
                                    type="date" 
                                    className="form-control" 
                                    id={items.labelName} 
                                    name={items.name} 
                                    min={today}
                                    defaultValue={(formData[items.value] || '')?.split('T')[0]}
                                    onChange={(e) => onChangeHandler(e)} 
                                    onBlur={onhandleFocus}
                                    focused={focused[items.labelName] && focused[items.labelName].toString()}
                                    required={items.required} 
                                    />
                                </div>
                            </Col>
                        )

                    case 'category-type-dropdown':
                        return (
                            <Col key={items.id} sm={6}>
                                <label
                                    htmlFor="Day"
                                    className="col-form-label"
                                >
                                    {t(items?.labelName)}
                                </label>
                                <div className="mb-3" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>

                                    <Multiselect
                                        options={QuestionTypes}
                                        selectedValues={QuestionTypes?.filter((item) => selectedCategoryType?.includes(item.ID))}
                                        onSelect={onSelectCategoryType}
                                        onRemove={onRemoveCategoryType}
                                        displayValue={i18n.language === 'en' ? 'NameEn' : 'NameAr'}
                                        placeholder={t("Category Type")}
                                        required={items.required}
                                        style={{
                                            multiselectContainer: {
                                                textAlign: i18n.language === 'ar' ? 'right' : 'left',
                                                direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
                                            },
                                            searchBox: {
                                                paddingRight: i18n.language === 'ar' ? '30px' : '',
                                                textAlign: i18n.language === 'ar' ? 'right' : 'left',
                                            },
                                            chips: {
                                                direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
                                                justifyContent: i18n.language === 'ar' ? 'flex-end' : 'flex-start',
                                            },
                                            optionContainer: {
                                                textAlign: i18n.language === 'ar' ? 'right' : 'left',
                                            },
                                        }}
                                    />

                                    {/* Hidden required input to trigger native validation */}
                                    <input
                                        type="text"
                                        value={selectedCategoryType.length ? 'valid' : ''}
                                        onChange={() => {}}
                                        required={items.required}
                                        style={{
                                            position: 'absolute',
                                            opacity: 0,
                                            height: 0,
                                            width: 0,
                                            pointerEvents: 'none',
                                            visibility: 'hidden',
                                        }}
                                    />
                                </div>
                            </Col>
                        )

                    case 'file':
                        return (
                            <Col key={items.id} sm={6}>
                                <label htmlFor="Icon" className="col-form-label">{t(items.labelName)} <small className="text-danger">*</small></label>
                                <CardBody>
                                    <div>
                                        <Dropzone
                                            onDrop={(acceptedFiles) => {
                                                handleImageUpload(acceptedFiles);
                                            }}
                                            // disabled={isDisabled}
                                        >
                                            {({ getRootProps, getInputProps }) => (
                                                <div className="dropzone dz-clickable" style={{minHeight: '60px'}}>
                                                    <div className="dz-message needsclick" {...getRootProps()}>
                                                        {/* <div className="mb-3">
                                                            <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                                        </div> */}
                                                        <h5>{t('DropFile')}</h5>
                                                    </div>
                                                </div>
                                            )}
                                        </Dropzone>

                                        { (selectedRow[items?.value] ||  selectedRow.preview) &&
                                            <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" id="dropzone-preview">
                                                <div className="p-2">
                                                    <Row className="align-items-center">
                                                        <Col className="col-auto">
                                                            {selectedRow[items?.value] ? (
                                                                <img
                                                                    data-dz-thumbnail=""
                                                                    height="80"
                                                                    className="avatar-sm rounded bg-light"
                                                                    src={selectedRow[items?.value]}
                                                                    // alt={f.name}
                                                                />
                                                            ) : (
                                                                <img
                                                                    data-dz-thumbnail=""
                                                                    height="80"
                                                                    className="avatar-sm rounded bg-light"
                                                                    alt={selectedRow.name}
                                                                    src={selectedRow.preview}
                                                                />
                                                            )}
                                                        </Col>
                                                        <Col>
                                                            <Link to="#" className="text-muted font-weight-bold">
                                                                {selectedRow.path}
                                                            </Link>
                                                            <p className="mb-0">
                                                                <strong>{selectedRow.formattedSize}</strong>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Card>
                                        }
                                    </div>
                                </CardBody>
                            </Col> )


                    default:
                        return null
                }
            })}
        </Row>
    )
}

export default AddQuestionCategoryForm